"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifyViews = void 0;
const command_manager_1 = require("../../command_manager");
const config_1 = require("../../config");
const lodash_1 = require("lodash");
const model_1 = require("../../model");
const types_1 = require("../../types");
const i18n_1 = require("../../exports/i18n");
const store_1 = require("../../exports/store");
exports.modifyViews = {
    undoable: true,
    execute: (context, options) => {
        const { model: state } = context;
        const { data, datasheetId: _datasheetId } = options;
        const activeDatasheetId = store_1.Selectors.getActiveDatasheetId(state);
        const datasheetId = _datasheetId || activeDatasheetId;
        const snapshot = store_1.Selectors.getSnapshot(state, datasheetId);
        if (!snapshot) {
            return null;
        }
        const views = snapshot.meta.views;
        if ((0, lodash_1.isEmpty)(data)) {
            return null;
        }
        const actions = data.reduce((collected, recordOption) => {
            const { viewId, key, value } = recordOption;
            // character is too long or not filled
            if (key === 'name' && (value.length > ((0, config_1.getCustomConfig)().VIEW_NAME_MAX_COUNT || 30) || value.length < 1)) {
                return collected;
            }
            // Check if there is a view with the same name
            if (key === 'name' && (0, lodash_1.find)(views, { name: value })) {
                throw new Error((0, i18n_1.t)(i18n_1.Strings.error_modify_view_failed_duplicate_name));
            }
            // Check if viewId exists
            if (!(0, lodash_1.find)(views, { id: viewId })) {
                throw new Error((0, i18n_1.t)(i18n_1.Strings.error_modify_view_failed_not_found_target));
            }
            const action = model_1.DatasheetActions.modifyView2Action(snapshot, { viewId, key, value });
            action && collected.push(...action);
            return collected;
        }, []);
        if (actions.length === 0) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: datasheetId,
            resourceType: types_1.ResourceType.Datasheet,
            actions,
        };
    },
};
/*

 declare module '../../command_manager/command_manager' {
 interface CollaCommandManager {
 execute(options: IModifyViewOptions & { cmd: 'ReplaceViews' });
 }
 }

 */
//# sourceMappingURL=modify_view.js.map